module.exports = __webpack_public_path__ + "static/media/ulysses.7740d55e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ulysses.png
// module id = 1427
// module chunks = 0